module.exports = __webpack_public_path__ + "img/loginQuoteImage05.20c38861.webp";